var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"big-card mandarinCard chinese-card"},[_c('div',{staticClass:"icon-box flex-start-center"},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.index))]),_c('span',{staticClass:"point"},[_vm._v(".")]),_c('span',{staticClass:"card-title"},[_vm._v("普通话水平")])]),_c('div',{staticClass:"margin-top"},[(!_vm.getEval.isEmpty)?[_c('DescribeData',{staticClass:"margin-bottom",attrs:{"describe":{
          label: '评估等级：',
          text: _vm.getEval.tag,
          color: _vm.getEval.color
        }}}),_c('DescribeData',{attrs:{"describe":{
          label: '详细评语',
          desc: _vm.getEval.text
        }}})]:[_c('div',{staticClass:"noanswer-module",staticStyle:{"box-sizing":"border-box"}},[_c('i',{staticClass:"iconfont iconfont-color"},[_vm._v("")]),_vm._v(" "+_vm._s(_vm.getEval.text || "候选人未作答")+" ")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }